"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getNamespace = _interopRequireDefault(require("./getNamespace"));
var _default = exports.default = function _default(namespace) {
  return (0, _getNamespace.default)(namespace, 'deps');
};